module.exports = __webpack_public_path__ + "img/933.0f8a0822.png";